import React, { useCallback, useState } from "react";
import Icon from "../../../../components/Icon/Icon";
import SpacingBox from "../../../../components/SpacingBox";
import useQuotePopup from "../../../../hooks/useQuotePopup";
import useWindowResize from "../../../../hooks/useWIndowResize";
import {
    WHO_CAN_HIRE_SECTION,
    WHO_CAN_HIRE_SECTION_DEFAULT_POSITION,
} from "../../../../constants/sections";
import "./IntroBenefits.css";
import Datalayer from "../../../../libs/vendors/data-layer";
import {
    CLICK_ACTIONS,
    CLICK_DESCRIPTION,
    MODAL_NAMES,
    MODAL_TYPES,
} from "../../../../constants/datalayer";
import Button from "../../../../components/Button/Button";
import noteIcon from '../../../../assets/images/icons/notes.svg';
import playCircle from '../../../../assets/images/icons/play-circle.svg';

const VideoModal = React.lazy(() => import("./VideoModal"));

function IntroBenefits() {
    const { isMobile } = useWindowResize();
    const { openQuotePopup } = useQuotePopup();
    const [openedModal, setOpenedModal] = useState(false);
    const openModal = useCallback(() => {
        setOpenedModal(true);
        Datalayer.sendClickAction(
            "Inicio",
            `${CLICK_ACTIONS.SELECT_VIDEO}: ${CLICK_DESCRIPTION.TUTORIAL_VIDEO}`
        );
        Datalayer.sendModal(MODAL_TYPES.INFO, MODAL_NAMES.LANDING_VIDEO);
    }, []);
    const closeModal = useCallback(() => {
        setOpenedModal(false);
        Datalayer.sendModal(
            MODAL_TYPES.INFO,
            MODAL_NAMES.LANDING_VIDEO,
            CLICK_ACTIONS.CLOSE_MODAL
        );
    }, []);

    const handleOnScrollTo = useCallback(() => {
        const element = document.getElementById(WHO_CAN_HIRE_SECTION);
        const top = !isMobile ? element.offsetTop : WHO_CAN_HIRE_SECTION_DEFAULT_POSITION;
        window.scroll({
            behavior: "smooth",
            top,
        });
        Datalayer.sendClickAction(
            "Inicio",
            `${CLICK_ACTIONS.SELECT_LINK}: ${CLICK_DESCRIPTION.BENEFITS}`
        );
    }, [isMobile]);

    const onOpenQuoteModal = useCallback(() => {
        openQuotePopup();
        Datalayer.sendClickAction(
            "Inicio",
            `Botón inferior: ${CLICK_DESCRIPTION.BTN_QUOTATION}`,
            {
                tipoZona: "Hogar",
                zona: "HogarLeads",
                subZona: "Inicio",
                seccion: "Página",
                tipoEvento: "clic",
                tipoElemento: "Botón",
                valor: "Botón:Solicitar Asesoría",
            }
        );
    }, [openQuotePopup]);

    return (
        <div className="landing-intro-benefits">
            <h2 className="landing-intro-benefits__title">
                Asegura tu casa o tus cosas
                <br />
                como quieras
            </h2>
            <SpacingBox mt="20" className="text-center">
                <Button
                    id="quote-here"
                    type="button"
                    className="landing-intro-benefits__quote rounded pink"
                    onClick={onOpenQuoteModal}
                >
                    Asesoría personalizada
                </Button>
            </SpacingBox>
            <div className="benefits-container">
                <div className="benefits-details">
                    <div className="benefits-details__more">
                        <Icon
                            className="benefits-details__link benefits-details__icon-notes"
                            name="notes"
                            image={noteIcon}
                            onClick={handleOnScrollTo}
                        />
                        <p className="benefits-details__bold">
                            Si eres propietario puedes proteger <br />
                            tu casa, tus cosas o las dos y si eres <br />
                            inquilino podrás proteger solo tus cosas.
                            <br />
                            <span
                                className="benefits-details__link"
                                onClick={handleOnScrollTo}
                                role="presentation"
                            >
                                Conoce más
                            </span>
                        </p>
                    </div>
                    <div className="benefits-details__video">
                        <Icon
                            className="benefits-details__link benefits-details__icon-play"
                            name="play-circle"
                            onClick={openModal}
                            image={playCircle}
                        />
                        <p className="benefits-details__bold">
                            <span
                                className="benefits-details__link "
                                onClick={openModal}
                                role="presentation"
                            >
                                Mira el video
                            </span>
                            <span className="benefits-details__new-line">
                                {" "}
                                y conoce cómo funciona.
                            </span>
                        </p>
                    </div>
                </div>
            </div>

            {openedModal && <VideoModal opened={openedModal} closeModal={closeModal} />}
        </div>
    );
}

export default React.memo(IntroBenefits);
